import React from 'react';
import {ViolationModel, ViolationSeverity} from '../../../domain/models/checkout/CartSummary/Violation.model';
import {Violation} from './Violation';
import {classes} from './Violations.st.css';

export interface ViolationsProps {
  dataHook: string;
  isTopBanner?: boolean;
  violations?: ViolationModel[];
}

export const Violations = ({isTopBanner, dataHook, violations}: ViolationsProps) => {
  if (!violations || violations.length === 0) {
    return null;
  }

  return (
    <div data-hook={dataHook} className={classes.root}>
      {violations.map((violation, index) => (
        <Violation
          key={index}
          severity={isTopBanner ? ViolationSeverity.warning : violation.severity}
          description={violation.description}
        />
      ))}
    </div>
  );
};
